const ACTIVITY_OPTIONS = [
    { label: "Potatura", value: "potatura" },
    { label: "Pulizia strada", value: "pulizia_strada" },

    { label: "Abbattimento", value: "abbattimento" },
    { label: "Reti di recinzione", value: "reti_recinzione" },
    { label: "Sfalcio", value: "sfalcio" },
    { label: "Reti paramassi", value: "reti_paramassi" },
    { label: "Diserbo", value: "diserbo" },
    { label: "Censimento arboreo", value: "censimento_arboreo" },
  ];
  
  export default ACTIVITY_OPTIONS;
  